const setPrimary = { set: 'podstawowy', href: 'https://edu-sense.com/pl/produkty/drewniane-puzzle-do-ozobota-zestaw-podstawowy?utm_source=puzzle&utm_medium=help' };
const setAdditional = { set: 'dodatkowy', href: 'https://edu-sense.com/pl/produkty/drewniane-puzzle-do-ozobota-zestaw-dodatkowy?utm_source=puzzle&utm_medium=help' };
// ToDo: const setAR = {set: 'zestaw puzzli AR', href: 'https://akademia.uczymydzieciprogramowac.pl/pl/produkty/nowosci/drewniane-puzzle-ar-rozszerzona-rzeczywistosc'};

export const purePuzzles = {
    ac: {
        id: 'ac',
        path: { pl: 'prosto.svg', en: 'prosto.svg', ua: 'prosto.svg' },
        set: [setPrimary],
        class: 'black-path',
        command: 'linia_prosta_pomoc',
        positions: 2,
        category: 'czarne_trasy_kat',
        tags: 'linia_tagi',
        description: 'linia_opis',
        rotate: 90
    },
    ae: {
        id: 'ae',
        path: {
            pl: 'skrzyzowanie_01.svg',
            en: 'skrzyzowanie_01.svg',
            ua: 'skrzyzowanie_01.svg'
        },
        set: [setPrimary],
        class: 'black-path',
        command: 'skrzyzowania_pomoc',
        positions: 1,
        category: 'czarne_trasy_kat',
        tags: 'skrzyzowania_tagi',
        description: 'skrzyzowanie_opis'
    },
    ab: {
        id: 'ab',
        path: {
            pl: 'biale_pole.svg',
            en: 'biale_pole.svg',
            ua: 'biale_pole.svg'
        },
        set: [setAdditional],
        class: 'black-path',
        command: 'biale_pole_pomoc',
        positions: 1,
        category: 'czarne_trasy_kat',
        tags: 'bialy_tagi',
        description: 'bialy_opis'
    },
    af: {
        id: 'af',
        path: {
            pl: 'skrzyzowanie_02.svg',
            en: 'skrzyzowanie_02.svg',
            ua: 'skrzyzowanie_02.svg'
        },
        set: [setPrimary],
        class: 'black-path',
        command: 'skrzyzowania_pomoc',
        positions: 4,
        category: 'czarne_trasy_kat',
        tags: 'skrzyzowania_tagi',
        description: 'skrzyzowanie_opis'
    },
    ad: {
        id: 'ad',
        path: { pl: 'skrec.svg', en: 'skrec.svg', ua: 'skrec.svg' },
        set: [setPrimary],
        class: 'black-path',
        command: 'zakret_pomoc',
        positions: 4,
        category: 'czarne_trasy_kat',
        tags: 'zakret_tagi',
        description: 'zakret_opis'
    },
    ah: {
        id: 'ah',
        path: { pl: 'prosta_cz.svg', en: 'prosta_cz.svg', ua: 'prosta_cz.svg' },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowa_linia_prosta_pomoc',
        positions: 2,
        category: 'czerwone_trasy_kat',
        tags: 'czerwona_linia_tagi',
        description: 'kolorowa_linia_opis',
        rotate: 90
    },
    aj: {
        id: 'aj',
        path: {
            pl: 'skrzyzowanie_cz.svg',
            en: 'skrzyzowanie_cz.svg',
            ua: 'skrzyzowanie_cz.svg'
        },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowe_skrzyzowania_pomoc',
        positions: 1,
        category: 'czerwone_trasy_kat',
        tags: 'czerwone_skrzyzowania_tagi',
        description: 'skrzyzowanie_opis'
    },
    ag: {
        id: 'ag',
        path: {
            pl: 'biale_pole_cz.svg',
            en: 'biale_pole_cz.svg',
            ua: 'biale_pole_cz.svg'
        },
        set: [setAdditional],
        class: 'black-path',
        command: 'biale_pole_pomoc',
        positions: 1,
        category: 'czerwone_trasy_kat',
        tags: 'bialy_tagi',
        description: 'bialy_opis'
    },
    ak: {
        id: 'ak',
        path: {
            pl: 'skrzyzowanie_T_cz.svg',
            en: 'skrzyzowanie_T_cz.svg',
            ua: 'skrzyzowanie_T_cz.svg'
        },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowe_skrzyzowania_pomoc',
        positions: 4,
        category: 'czerwone_trasy_kat',
        tags: 'czerwone_skrzyzowania_tagi',
        description: 'skrzyzowanie_opis'
    },
    ai: {
        id: 'ai',
        path: { pl: 'zakret_cz.svg', en: 'zakret_cz.svg', ua: 'zakret_cz.svg' },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowe_zakrety_pomoc',
        positions: 4,
        category: 'czerwone_trasy_kat',
        tags: 'czerwony_zakret_tagi',
        description: 'kolorowy_zakret'
    },
    am: {
        id: 'am',
        path: {
            pl: 'prosta_ziel.svg',
            en: 'prosta_ziel.svg',
            ua: 'prosta_ziel.svg'
        },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowa_linia_prosta_pomoc',
        positions: 2,
        category: 'zielone_trasy_kat',
        tags: 'zielona_linia_tagi',
        description: 'kolorowa_linia_opis',
        rotate: 90
    },
    ao: {
        id: 'ao',
        path: {
            pl: 'skrzyzowanie_ziel.svg',
            en: 'skrzyzowanie_ziel.svg',
            ua: 'skrzyzowanie_ziel.svg'
        },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowe_skrzyzowania_pomoc',
        positions: 1,
        category: 'zielone_trasy_kat',
        tags: 'zielone_skrzyzowania_tagi',
        description: 'skrzyzowanie_opis'
    },
    al: {
        id: 'al',
        path: {
            pl: 'biale_pole_ziel.svg',
            en: 'biale_pole_ziel.svg',
            ua: 'biale_pole_ziel.svg'
        },
        set: [setAdditional],
        class: 'black-path',
        command: 'biale_pole_pomoc',
        positions: 1,
        category: 'zielone_trasy_kat',
        tags: 'bialy_tagi',
        description: 'bialy_opis'
    },
    ap: {
        id: 'ap',
        path: {
            pl: 'skrzyzowanie_T_ziel.svg',
            en: 'skrzyzowanie_T_ziel.svg',
            ua: 'skrzyzowanie_T_ziel.svg'
        },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowe_skrzyzowania_pomoc',
        positions: 4,
        category: 'zielone_trasy_kat',
        tags: 'zielone_skrzyzowania_tagi',
        description: 'skrzyzowanie_opis'
    },
    an: {
        id: 'an',
        path: {
            pl: 'zakret_ziel.svg',
            en: 'zakret_ziel.svg',
            ua: 'zakret_ziel.svg'
        },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowe_zakrety_pomoc',
        positions: 4,
        category: 'zielone_trasy_kat',
        tags: 'zielony_zakret_tagi',
        description: 'kolorowy_zakret'
    },
    as: {
        id: 'as',
        path: {
            pl: 'prosta_nieb.svg',
            en: 'prosta_nieb.svg',
            ua: 'prosta_nieb.svg'
        },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowa_linia_prosta_pomoc',
        positions: 2,
        category: 'niebieskie_trasy_kat',
        tags: 'niebieska_linia_tagi',
        description: 'kolorowa_linia_opis',
        rotate: 90
    },
    au: {
        id: 'au',
        path: {
            pl: 'skrzyzowanie_nieb.svg',
            en: 'skrzyzowanie_nieb.svg',
            ua: 'skrzyzowanie_nieb.svg'
        },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowe_skrzyzowania_pomoc',
        positions: 1,
        category: 'niebieskie_trasy_kat',
        tags: 'niebieskie_skrzyzowania_tagi',
        description: 'skrzyzowanie_opis'
    },
    ar: {
        id: 'ar',
        path: {
            pl: 'biale_pole_nieb.svg',
            en: 'biale_pole_nieb.svg',
            ua: 'biale_pole_nieb.svg'
        },
        set: [setAdditional],
        class: 'black-path',
        command: 'biale_pole_pomoc',
        positions: 1,
        category: 'niebieskie_trasy_kat',
        tags: 'bialy_niebieski_tagi',
        description: 'bialy_opis'
    },
    aw: {
        id: 'aw',
        path: {
            pl: 'skrzyzowanie_T_nieb.svg',
            en: 'skrzyzowanie_T_nieb.svg',
            ua: 'skrzyzowanie_T_nieb.svg'
        },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowe_skrzyzowania_pomoc',
        positions: 4,
        category: 'niebieskie_trasy_kat',
        tags: 'niebieskie_skrzyzowania_tagi',
        description: 'skrzyzowanie_opis'
    },
    at: {
        id: 'at',
        path: {
            pl: 'zakret_nieb.svg',
            en: 'zakret_nieb.svg',
            ua: 'zakret_nieb.svg'
        },
        set: [setAdditional],
        class: 'red-path green-path blue-path',
        command: 'kolorowe_zakrety_pomoc',
        positions: 4,
        category: 'niebieskie_trasy_kat',
        tags: 'niebieski_zakret_tagi',
        description: 'kolorowy_zakret'
    },
    ax: {
        id: 'ax',
        path: { pl: 'start.svg', en: 'start.svg', ua: 'start.svg' },
        set: [setPrimary, setAdditional],
        class: 'start-path',
        command: 'start_kat',
        positions: 4,
        category: 'start_kat',
        tags: 'start_tagi',
        description: 'start_opis'
    },
    ay: {
        id: 'ay',
        path: { pl: 'koniec.svg', en: 'game_over.svg', ua: 'game_over.svg' },
        set: [setPrimary, setAdditional],
        class: 'end-path',
        command: 'koniec_kat',
        positions: 4,
        category: 'koniec_kat',
        tags: 'koniec_tagi',
        description: 'koniec_opis'
    },
    az: {
        id: 'az',
        path: {
            pl: 'jedz_prosto.svg',
            en: 'go_straight.svg',
            ua: 'go_straight.svg'
        },
        set: [setPrimary],
        class: 'forward-path',
        command: 'jedz_prosto_kat',
        positions: 4,
        category: 'jedz_prosto_kat',
        tags: 'jedz_prosto_tagi',
        description: 'jedz_prosto_opis',
        rotate: 270
    },
    ba: {
        id: 'ba',
        path: { pl: 'skrec_w_lewo.svg', en: 'go_left.svg', ua: 'go_left.svg' },
        set: [setPrimary],
        class: 'turn-left',
        command: 'skrec_w_lewo_kat',
        positions: 4,
        category: 'skrec_w_lewo_kat',
        tags: 'skrec_w_lewo_tagi',
        description: 'skrec_w_lewo_opis',
        rotate: 270
    },
    bb: {
        id: 'bb',
        path: { pl: 'skrec_w_prawo.svg', en: 'go_right.svg', ua: 'go_right.svg' },
        set: [setPrimary],
        class: 'turn-right',
        command: 'skrec_w_prawo_kat',
        positions: 4,
        category: 'skrec_w_prawo_kat',
        tags: 'skrec_w_prawo_tagi',
        description: 'skrec_w_prawo_opis',
        rotate: 270
    },
    bc: {
        id: 'bc',
        path: { pl: 'turbo.svg', en: 'turbo.svg', ua: 'turbo.svg' },
        set: [setPrimary],
        class: 'go-turbo',
        command: 'turbo_kat',
        positions: 4,
        category: 'turbo_kat',
        tags: 'turbo_tagi',
        description: 'turbo_opis',
        rotate: 270
    },
    bd: {
        id: 'bd',
        path: { pl: 'jedz_wolno.svg', en: 'slow.svg', ua: 'slow.svg' },
        set: [setPrimary],
        class: 'go-slowly',
        command: 'jedz_wolno_kat',
        positions: 4,
        category: 'jedz_wolno_kat',
        tags: 'jedz_wolno_tagi',
        description: 'jedz_wolno_opis',
        rotate: 270
    },
    be: {
        id: 'be',
        path: { pl: 'pauza.svg', en: 'pause.svg', ua: 'pause.svg' },
        set: [setPrimary],
        class: 'pause',
        command: 'pauza_kat',
        positions: 4,
        category: 'pauza_kat',
        tags: 'pauza_tagi',
        description: 'pauza_opis',
        rotate: 270
    },
    bf: {
        id: 'bf',
        path: { pl: 'rotacja.svg', en: 'tornado.svg', ua: 'tornado.svg' },
        set: [setPrimary],
        class: 'rotation',
        command: 'tornado_lub_obrot_kat',
        positions: 4,
        category: 'tornado_lub_obrot_kat',
        tags: 'tornado_lub_obrot_tagi',
        description: 'tornado_lub_obrot_opis',
        rotate: 270
    },
    bg: {
        id: 'bg',
        path: { pl: 'zawroc.svg', en: 'u-turn.svg', ua: 'u-turn.svg' },
        set: [[Object], [Object]],
        class: 'u-turn',
        command: 'zawroc_kat',
        positions: 4,
        category: 'zawroc_kat',
        tags: 'zawroc_tagi',
        description: 'zawroc_opis'
    },
    bh: {
        id: 'bh',
        path: {
            pl: 'szukaj_na_wprost.svg',
            en: 'line_jump_straight.svg',
            ua: 'line_jump_straight.svg'
        },
        set: [setAdditional],
        class: 'search-lines',
        command: 'szukaj_linii_na_wprost_kat',
        positions: 4,
        category: 'szukaj_linii_na_wprost_kat',
        tags: 'szukaj_linii_na_wprost_tagi',
        description: 'szukaj_linii_na_wprost_opis'
    },
    bi: {
        id: 'bi',
        path: {
            pl: 'szukaj_po_lewej.svg',
            en: 'line_jump_left.svg',
            ua: 'line_jump_left.svg'
        },
        set: [setAdditional],
        class: 'search-left',
        command: 'szukaj_linii_po_lewej_kat',
        positions: 4,
        category: 'szukaj_linii_po_lewej_kat',
        tags: 'szukaj_linii_po_lewej_tagi',
        description: 'szukaj__linii_po_lewej_opis'
    },
    bj: {
        id: 'bj',
        path: {
            pl: 'szukaj_po_prawej.svg',
            en: 'line_jump_right.svg',
            ua: 'line_jump_right.svg'
        },
        set: [setAdditional],
        class: 'search-right',
        command: 'szukaj_linii_po_prawej_kat',
        positions: 4,
        category: 'szukaj_linii_po_prawej_kat',
        tags: 'szukaj_linii_po_prawej_tagi',
        description: 'szukaj_linii_po_prawej_opis'
    },
    bk: {
        id: 'bk',
        path: {
            pl: 'zygzak.svg',
            en: 'zigzag_backwalk.svg',
            ua: 'zigzag_backwalk.svg'
        },
        set: [setAdditional],
        class: 'zigzac',
        command: 'zygzak_lub_spacer_w_tyl_kat',
        positions: 4,
        category: 'zygzak_lub_spacer_w_tyl_kat',
        tags: 'zygzak_lub_spacer_w_tyl_tagi',
        description: 'zygzak_lub_spacer_w_tyl_opis'
    },
    bl: {
        id: 'bl',
        path: {
            pl: 'stoper.svg',
            en: 'timer_on_off.svg',
            ua: 'timer_on_off.svg'
        },
        set: [setAdditional],
        class: 'timer',
        command: 'stoper_kat',
        positions: 4,
        category: 'stoper_kat',
        tags: 'stoper_tagi',
        description: 'stoper_opis'
    },
    bo: {
        id: 'bo',
        path: {
            pl: 'licz_skrzyzowania.svg',
            en: 'ENABLE_X-ING_COUNTER.svg',
            ua: 'ENABLE_X-ING_COUNTER.svg'
        },
        set: [setAdditional],
        class: 'count-crosses',
        command: 'licz_skrzyzowania_kat',
        positions: 4,
        category: 'licz_skrzyzowania_kat',
        tags: 'licz_skrzyzowania_tagi',
        description: 'licz_skrzyzowania_opis'
    },
    bp: {
        id: 'bp',
        path: {
            pl: 'licz_skrety.svg',
            en: 'enable_turn_counter.svg',
            ua: 'enable_turn_counter.svg'
        },
        set: [setAdditional],
        class: 'count-turns',
        command: 'licz_skrety_kat',
        positions: 4,
        category: 'licz_skrety_kat',
        tags: 'licz_skrety_tagi',
        description: 'licz_skrety_opis'
    },
    br: {
        id: 'br',
        path: {
            pl: 'licz_kolorowe.svg',
            en: 'enable_path_colour_counter.svg',
            ua: 'enable_path_colour_counter.svg'
        },
        set: [setAdditional],
        class: 'count-colorful-paths',
        command: 'licz_kolorowe_sciezki_kat',
        positions: 4,
        category: 'licz_kolorowe_sciezki_kat',
        tags: 'licz_kolorowe_sciezki_tagi',
        description: 'licz_kolorowe_sciezki_opis'
    },
    bs: {
        id: 'bs',
        path: {
            pl: 'komenda_dwukratkowa.svg',
            en: 'komenda_dwukratkowa.svg',
            ua: 'komenda_dwukratkowa.svg'
        },
        class: 'commands',
        command: 'komenda_dwukratkowa_pomoc',
        positions: 4,
        category: 'miejsce_na_komende_kat',
        tags: 'komenda_dwukratkowa_tagi',
        description: 'komenda_dwukratkowa_opis'
    },
    bt: {
        id: 'bt',
        path: {
            pl: 'komenda_trzykratkowa.svg',
            en: 'komenda_trzykratkowa.svg',
            ua: 'komenda_trzykratkowa.svg'
        },
        class: 'commands',
        command: 'komenda_trzykratkowa_pomoc',
        positions: 2,
        category: 'miejsce_na_komende_kat',
        tags: 'komenda_trzykratkowa_tagi',
        description: 'komenda_trzykratkowa_opis'
    },
    bu: {
        id: 'bu',
        path: {
            pl: 'komenda_czterokratkowa.svg',
            en: 'komenda_czterokratkowa.svg',
            ua: 'komenda_czterokratkowa.svg'
        },
        class: 'commands',
        command: 'komenda_czterokratkowa_pomoc',
        positions: 2,
        category: 'miejsce_na_komende_kat',
        tags: 'komenda_czterokratkowa_tagi',
        description: 'komenda_czterokratkowa_opis'
    },
    bw: {
        id: 'bw',
        path: { pl: 'uzupelnij.svg', en: 'complete.svg', ua: 'complete.svg' },
        class: 'add-path',
        command: 'uzupelnij_kat',
        positions: 1,
        category: 'uzupelnij_kat',
        tags: 'uzupelnij_tagi',
        description: 'uzupelnij_opis'
    },
    bx: {
        id: 'bx',
        path: { pl: 'banany.svg', en: 'banany.svg', ua: 'banany.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    by: {
        id: 'by',
        path: { pl: 'truskawka.svg', en: 'truskawka.svg', ua: 'truskawka.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    bz: {
        id: 'bz',
        path: { pl: 'cytryna.svg', en: 'cytryna.svg', ua: 'cytryna.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    ca: {
        id: 'ca',
        path: { pl: 'wisnie.svg', en: 'wisnie.svg', ua: 'wisnie.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cb: {
        id: 'cb',
        path: { pl: 'jablko.svg', en: 'jablko.svg', ua: 'jablko.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cc: {
        id: 'cc',
        path: { pl: 'burza.svg', en: 'burza.svg', ua: 'burza.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cd: {
        id: 'cd',
        path: { pl: 'grad.svg', en: 'grad.svg', ua: 'grad.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    ce: {
        id: 'ce',
        path: { pl: 'snieg.svg', en: 'snieg.svg', ua: 'snieg.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cf: {
        id: 'cf',
        path: {
            pl: 'slonce_deszcz.svg',
            en: 'slonce_deszcz.svg',
            ua: 'slonce_deszcz.svg'
        },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cg: {
        id: 'cg',
        path: { pl: 'deszcz.svg', en: 'deszcz.svg', ua: 'deszcz.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    ch: {
        id: 'ch',
        path: { pl: 'bocian.svg', en: 'bocian.svg', ua: 'bocian.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    ci: {
        id: 'ci',
        path: { pl: 'gawron.svg', en: 'gawron.svg', ua: 'gawron.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cj: {
        id: 'cj',
        path: { pl: 'gil.svg', en: 'gil.svg', ua: 'gil.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    ck: {
        id: 'ck',
        path: { pl: 'kukulka.svg', en: 'kukulka.svg', ua: 'kukulka.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cl: {
        id: 'cl',
        path: { pl: 'sikorka.svg', en: 'sikorka.svg', ua: 'sikorka.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cm: {
        id: 'cm',
        path: { pl: 'skowronek.svg', en: 'skowronek.svg', ua: 'skowronek.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cn: {
        id: 'cn',
        path: { pl: 'slowik.svg', en: 'slowik.svg', ua: 'slowik.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    co: {
        id: 'co',
        path: { pl: 'wrobel.svg', en: 'wrobel.svg', ua: 'wrobel.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cp: {
        id: 'cp',
        path: { pl: 'balwan_1.svg', en: 'balwan_1.svg', ua: 'balwan_1.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cr: {
        id: 'cr',
        path: { pl: 'balwan_2.svg', en: 'balwan_2.svg', ua: 'balwan_2.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cs: {
        id: 'cs',
        path: { pl: 'balwan_3.svg', en: 'balwan_3.svg', ua: 'balwan_3.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    ct: {
        id: 'ct',
        path: { pl: 'balwan_4.svg', en: 'balwan_4.svg', ua: 'balwan_4.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cu: {
        id: 'cu',
        path: { pl: 'balwan_5.svg', en: 'balwan_5.svg', ua: 'balwan_5.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cw: {
        id: 'cw',
        path: { pl: 'szyszka_1.svg', en: 'szyszka_1.svg', ua: 'szyszka_1.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cx: {
        id: 'cx',
        path: { pl: 'szyszka_2.svg', en: 'szyszka_2.svg', ua: 'szyszka_2.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cy: {
        id: 'cy',
        path: { pl: 'szyszka_3.svg', en: 'szyszka_3.svg', ua: 'szyszka_3.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    cz: {
        id: 'cz',
        path: { pl: 'szyszka_4.svg', en: 'szyszka_4.svg', ua: 'szyszka_4.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    da: {
        id: 'da',
        path: { pl: 'kolory.svg', en: 'kolory.svg', ua: 'kolory.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    db: {
        id: 'db',
        path: { pl: 'kredki.svg', en: 'kredki.svg', ua: 'kredki.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    dc: {
        id: 'dc',
        path: { pl: 'ksiazka.svg', en: 'ksiazka.svg', ua: 'ksiazka.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    dd: {
        id: 'dd',
        path: { pl: 'pilka.svg', en: 'pilka.svg', ua: 'pilka.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    de: {
        id: 'de',
        path: { pl: 'grzyb_1.svg', en: 'grzyb_1.svg', ua: 'grzyb_1.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    df: {
        id: 'df',
        path: { pl: 'grzyb_2.svg', en: 'grzyb_2.svg', ua: 'grzyb_2.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    dg: {
        id: 'dg',
        path: { pl: 'grzyb_3.svg', en: 'grzyb_3.svg', ua: 'grzyb_3.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    dh: {
        id: 'dh',
        path: { pl: 'grzyb_4.svg', en: 'grzyb_4.svg', ua: 'grzyb_4.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    di: {
        id: 'di',
        path: { pl: 'grzyb_5.svg', en: 'grzyb_5.svg', ua: 'grzyb_5.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    dj: {
        id: 'dj',
        path: { pl: 'grzyb_6.svg', en: 'grzyb_6.svg', ua: 'grzyb_6.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    dk: {
        id: 'dk',
        path: { pl: 'szkola.svg', en: 'szkola.svg', ua: 'szkola.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    },
    dl: {
        id: 'dl',
        path: { pl: 'park.svg', en: 'park.svg', ua: 'park.svg' },
        class: 'illustrations',
        command: 'ilustracje_do_zadan_kat',
        positions: 1,
        category: 'ilustracje_do_zadan_kat',
        tags: 'ilustracje_do_zadan_tagi',
        description: 'ilustracje_do_zadan_opis'
    }
}



// WEBPACK FOOTER //
// ./src/purePuzzles.js